import {
  BasePairName,
  BaseSymbol,
  PairName,
} from '@ui/assets/config/trade-pair-listings';
import { TradePairTag } from '@ui/constants/tokens/tradePairTags';
import { Address } from '@ui/types/alias';
import { BareTradePair } from '@ui/types/tradePair';
import BigNumber from 'bignumber.js';

import {
  PairResponse,
  PairResponsePairTypeEnum,
  PairResponseStatusEnum,
} from '../../generated';

type PairResponseWithPythPro = PairResponse & {
  pythProPriceFeedId?: number | string;
};

export const toPair = (data: PairResponse): BareTradePair => {
  const { pythProPriceFeedId } = data as PairResponseWithPythPro;

  return {
    ticker: data.pythSymbol,
    pythPriceFeedId: data.pythPriceFeedId ?? '', // should be non null after BE migrate
    pythProPriceFeedId:
      pythProPriceFeedId === undefined ? "1" : String(pythProPriceFeedId),
    volumeUSDSnapshot: new BigNumber(data.volumeUSD),
    pairName: data.pairName as PairName,
    baseName:
      data.pairType === PairResponsePairTypeEnum.Forex
        ? (data.pairName as BasePairName)
        : (`${data.symbol}/${getQuote(data.pairName)}` as BasePairName),
    baseSymbol: data.symbol as BaseSymbol,
    address: data.base as Address,
    nextClose: data.nextClose ? new Date(data.nextClose) : null,
    nextOpen: data.nextOpen ? new Date(data.nextOpen) : null,
    isOpen: data.status !== PairResponseStatusEnum.Close, // case can be : pair is open but reduce only, so only check if not close will be enough
    schedule: data.schedule ?? null,
    pairStatus: data.status,
    priceDisplayDecimals: data.priceDisplayDecimals,
    image:
      data.icon ??
      (data.pairType === PairResponsePairTypeEnum.Forex
        ? `/tokens/${data.pairName}.svg`
        : `/tokens/${data.symbol}.svg`),
    listedAt: new Date(data.listAt),
    type: data.pairType,
    isDegenPair: data.isDegenPair,
    tags: data.tags as TradePairTag[],
  };
};

/**
 * BTC/USD => USD
 */
export const getQuote = (pairName: string) => {
  return pairName.split('/')[1];
};
